import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { SupplierSearchProvider } from './context/supplier-search-context';
import { SupplierSearchComponent } from './supplier-search-component';

export function SupplierSearchFactory() {
    return (
        <BaseLayoutFactory>
            <SupplierSearchProvider>
                <SupplierSearchComponent />
            </SupplierSearchProvider>
        </BaseLayoutFactory>
    );
}
